<template>
  <div class="addMember">
    <div class="search flex-box bb">
      <label for="searchUser" class="flex2 flex-box flex-v-c" :class="{br:searchUserId}">
        <input
          id="searchUser"
          class="searchUser"
          type="number"
          @input="inputNull"
          placeholder="输入玩家ID查询"
          v-model="searchUserId"
        >
        <div class="closeBtn" v-show="searchUserId" @click="clear"></div>
      </label>
      <div class="flex1 flex-box flex-hv-c" @click="search" v-show="searchUserId">
        <div class="button">
          搜索
          <i class="iconfont icon-search"></i>
        </div>
      </div>
    </div>

    <div class="info">
      <ul>
        <img class="avatar" :src="data.headimgurl" alt>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">玩家ID：{{data.userId}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">昵称：{{data.nickname}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">地址：{{data.province}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">充值量：{{data.recharge}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">该玩家所绑定的代理ID：{{data.userMember}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">所属商务：{{data.realname}}</span>
        </li>
        <!--<li class="flex-box flex-v-c bb"><span v-if="data">上级代理：{{data.memberReferrer}}</span></li>
        <li class="flex-box flex-v-c bb"><span v-if="data">是否代理：<span v-if="data.level">{{data.level}}</span><span v-else>否</span></span></li>
        <li class="flex-box flex-v-c bb"><span v-if="data">创建时间：{{data.createTime}}</span></li>-->
        <div class="button setMemberBtn" v-if="data && !data.memberId" @click="setMember">设置代理</div>
        <!--<div class="button setMemberBtn" v-if="data && !data.level && data.memberReferrer != myMemberId">该玩家已绑定别的代理</div>-->
        <!--后台已判断-->
        <div class="button setMemberBtn" v-if="data && data.memberId">该玩家已是代理</div>
      </ul>
    </div>
  </div>
</template>
<!--javascript-->
<script>
export default {
  name: 'addMember',
  data: function () {
    return {
      data: '',
      myMemberId: this.$store.state.userMsg.userMsg.memberId,
      searchUserId: '',
    }
  },
  methods: {
    search() {
      this.$http.get('/player/Info', { params: { userId: this.searchUserId } }).then((res) => {
        if (res.code == 0) {
          this.data = res.data
        } else {
          this.$toast(res.message)
        }
      })
    },
    setMember() {
      var that = this
      if (this.data.userMember) {//已绑定
        this.$messagebox.confirm('确认授权该玩家成为代理?', '提示').then((option) => {
          this.$http.post('/member/add', { userId: this.searchUserId }).then((res) => {
            if (res.code == 0) {
              this.$toast('授权成功！')
            } else {
              this.$toast(res.message)
            }
          })
        })
      } else {//未绑定
        this.$http.post('/member/sendCode', { userId: this.searchUserId }).then((res) => {
          if (res.code != 0) {
            this.$toast(res.message)
          }
        });
        this.$messagebox.prompt('请输入该玩家验证码?', '提示').then((value, option) => {
          if (!value) {
            this.$toast('请先输入验证码！')
            return
          }
          this.$http.post('/member/add', { userId: this.searchUserId, code: value.value }).then((res) => {
            if (res.code == 0) {
              this.$toast('授权成功！')
              that.search()
            } else {
              this.$toast(res.message)
            }
          })
        })
      }
    },
    inputNull() {
      this.data = ''
    },
    clear() {
      this.searchUserId = ''
      this.data = ''
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.addMember {
  height: 100%;
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.search {
  height: 1rem;
}

.search:focus-within {
  border-bottom: 1px solid rgb(16, 135, 139);
}

.avatar {
  width: 1rem;
  height: 1rem;
  border-radius: 4px;
  box-shadow: 5px 4px 6px #ddd;
}

.searchUser {
  width: 100%;
  padding-left: 10px;
  text-align: center;
}

.setMemberBtn {
  margin-top: 0.5rem;
  height: 0.7rem;
}

.info ul {
  padding: 0 0.5rem;
  margin-top: 0.5rem;
  li {
    height: 0.7rem;
  }
}

.button {
}
</style>



// WEBPACK FOOTER //
// src/components/addMember/index.vue